import React from "react";
import { FormattedMessage } from "react-intl";
import LoadingArea from "theme/components/molecules/LoadingArea";

const PublishProductReviewLoading = () => {
  return (
    <LoadingArea>
      <FormattedMessage
        id="modules.Reviews.PublishProductReview.loading"
        defaultMessage="Loading review form"
      />
    </LoadingArea>
  );
};

export default PublishProductReviewLoading;
